interface Props { className?: string; reverse?: boolean; top?: boolean }
const WaveSeparator = ({ className = "" }: Props) => (
  <div className={`container-editorial ${className}`}><div className="hairline" aria-hidden="true" /></div>
)
export default WaveSeparator
